// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-framer"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M12 15V21.5L5.5 15V8.5H12L18.5 15H12Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M18.5 2H5.5L12 8.5H18.5V2Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 8.5L18.5 15H12V21.5L5.5 15V8.5H12ZM12 8.5L5.5 2H18.5V8.5H12Z","strokeWidth":"props.strokeWidth"}}]}]};

const LogoFramerIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-framer',
    ref,
    icon: element,
  },
));

LogoFramerIcon.displayName = 'LogoFramerIcon';

export default LogoFramerIcon;
